import React from 'react';
import { Button, Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useAuth0 } from '@auth0/auth0-react';
import { modifyImageApi } from '../api/imageApi';


interface FormatProfileProps {
  id: string,
  accept?: string,
  maxWidth?: number,
  maxHeight?: number,
  aspectRatio?: number,
  src: string,
  onChange: (selectedFile: string) => void
}

export function FormatProfileButton(props: FormatProfileProps) {

  const [openDialog, setOpenDialog] = React.useState<boolean>(false);

  const [image, setImage] = React.useState<string>(props.src);
  const [formatImage, setFormatImage] = React.useState<string>(props.src);

  const [pageState, setPageState] = React.useState<string>('imageSelected');
  const [aspectRatio, setAspectRatio] = React.useState<number>(props.aspectRatio ?? 1);

  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  async function handleClose() {
    setOpenDialog(false);
  }

  async function updateFile() {

    let accessToken = await getAccessTokenSilently({ audience: `${process.env.REACT_APP_AUTH0_AUDIENCE}`, });


    const modifyImageCommand =
    {
      cropToHeadshot: false,
      replaceBackground: true,
      removeBackground: false,
      image: image
    };

    console.log('modifyImageCommand');
    const result = await modifyImageApi(accessToken, modifyImageCommand);


    setFormatImage(result.image);

    setPageState('imageFormatted');

  }

  async function saveFile() {

    if (formatImage) {
      props.onChange(formatImage);
    }

    setOpenDialog(false);
  }

  async function returnToEdit() {
    setPageState('imageSelected');
  }

  const onEdit = async ({ target }: any) => {
    setOpenDialog(true);
  }

  function isState(state: string): boolean {
    return state === pageState;
  }

  return (
    <>
      <Grid container>
        <Grid item xs={3}>
          <Button color="secondary" variant="contained" component="span" onClick={onEdit}>
            Scrub Bkg
          </Button>
        </Grid>
      </Grid>

      <Dialog open={openDialog} sx={{ width: 800 }}  >
        <DialogTitle>Scrub Bkg</DialogTitle>
        <DialogContent>

          {isState('imageSelected') && <img alt='selectImage' src={image} style={{ width: 250 }} />}
          {isState('imageFormatted') && <img alt='formatImage' src={formatImage} style={{ width: 250 }} />}

        </DialogContent>
        <DialogActions>
          {isState('imageFormatted') && <Button onClick={returnToEdit}>Undo</Button>}
          {isState('imageSelected') && <Button onClick={updateFile}>Update</Button>}
          {isState('imageFormatted') && <Button onClick={saveFile}>Save</Button>}
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );

}